export default __webpack_public_path__ + "static/media/Connect_4.6550fdf7.png";